import { useContext, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { updateProductBatchDetails } from "../../../services/inventory";
import { cleanObject, getRandomIntInclusive } from "../../../helpers";
import { RequestLoader, ToastContext } from "../../../hooks/context";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../routes/pathContants";

const useProductBatchForm = ({ batchInfo }) => {
  const { setRequestLoaderProgress } = useContext(RequestLoader);
  const triggerToast = useContext(ToastContext);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const [batchDetails, setBatchDetails] = useState({
    product_name: batchInfo?.product_name || "",
    batch_id: batchInfo?.batch_id || "",
    batch_name: batchInfo?.batch_name || "",
    cost_price: batchInfo?.cost_price || 0,
    selling_price: batchInfo?.selling_price || 0,
    stock_quantity: batchInfo?.stock_quantity || "",
    discount_rate: batchInfo?.discount_rate || "",
    expiry_date: batchInfo?.expiry_date || "",
  });

  const { mutate: updateProductBatch, isLoading: isEditingProductBatch } =
    useMutation((data) => updateProductBatchDetails(data));

  const handleEditProductBatch = () => {
    setRequestLoaderProgress(getRandomIntInclusive(10, 50));

    const data = cleanObject(batchDetails);
    updateProductBatch(
      { data, id: batchInfo?.product_id },
      {
        onSuccess: () => {
          triggerToast("Product Batch update successful", "success");
          queryClient.invalidateQueries(["getProductBatchDetails"]);
          queryClient.invalidateQueries(["getProductsBatch"]);
          navigate(pathConstants.INVENTORY_PRODUCTS_BATCH);
        },
      },
    );
  };

  return {
    batchDetails,
    setBatchDetails,
    isEditingProductBatch,
    handleEditProductBatch,
  };
};

export default useProductBatchForm;
